class MedicalProfileController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            } else {
                getMedicalProfile()
            }
        }
        let userId = localStorageService.get('user_id')
        let schoolId = localStorageService.get('school_id')
        let academicYear = localStorageService.get('academic_year')

        let profileObj = {
            patient_id: userId,
            role: $scope.role
        }

        function getMedicalProfile() {
            authService.callAPI(MEDICALCONSTANT.API_GET_MEDICAL_PROFILE, "POST", profileObj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data.length > 0) {
                        $scope.userDetails = response.result.data.data[0]
                        let curriculumName = ($scope.userDetails.curriculum && $scope.userDetails.curriculum.name) ? $scope.userDetails.curriculum.name : ""
                        let className = ($scope.userDetails.class && $scope.userDetails.class.name) ? $scope.userDetails.class.name : ""
                        let batchName = ($scope.userDetails.batch && $scope.userDetails.batch.name) ? $scope.userDetails.batch.name : ""
                        let sessionName = ($scope.userDetails.session && $scope.userDetails.session.name) ? $scope.userDetails.session.name : ""
                        $scope.userDetails['academicDet'] = curriculumName + '/' + sessionName + '/' + className + batchName
                        if ($scope.userDetails.incidents && $scope.userDetails.incidents.length > 0)
                            $scope.incidentList = $scope.userDetails.incidents
                        getImmunizationForm()
                    }
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }
        let userObj = {
            patient_id: userId,
            academic_year: academicYear,
            school_id: schoolId
        }

        function getImmunizationForm() {
            authService.callAPI(MEDICALCONSTANT.API_GET_USER_IMM_FORM, "POST", userObj, (response) => {
                console.log(response)
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data.length > 0) {
                        let resultData = response.result.data.data[0]
                        $scope.immunizationResults = resultData.questions_answers
                        if (resultData.status === "sent") {
                            $scope.viewAnswers = false
                            $scope.sent_date = resultData.sent_date
                        } else if (resultData.status === "replied") {
                            $scope.viewAnswers = true
                            $scope.sent_date = resultData.sent_date
                            $scope.reply_date = resultData.reply_date
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }

                }
            })
        }

        /*$scope.subscribe('getPatientUsers');
        Meteor.subscribe('getImmuzationQuestions', schoolId)
        Meteor.subscribe('getImmuzationReply', schoolId)
        Meteor.call("currentDate", function(error, result) {
            if (error) {

            } else {
                $scope.serverDate = result;
                $scope.$apply()
            }
        })*/
        /*$scope.autorun(() => {
            $scope.subscribe('getPatientProfile', () => {
                return [userId]
            }, () => {
                $scope.result = Person.findOne({
                    user_id: userId,
                    "status": "active"
                })
                if ($scope.result && $scope.result.incidents) {
                    $scope.incidentList = $scope.result.incidents
                }

            })*/


        $scope.medicalhistory = [{
                "op": "dvsd"
            }]
            /*if (userId) {
                Meteor.call('getPersonDetails', schoolId, userId, (error, result) => {
                    if (error) {

                    } else {
                        if (result.image) {
                            if (result.image.original) {
                                $scope.profilePic = FILE_PREVIEW_URL + result.image.original
                            }
                        } else {
                            $scope.profilePic = "icons/studentprofile.png"
                        }
                        $scope.selectedPersonData = result.selectedPersonData
                        if (result.incidentList) {
                            $scope.incidentList = result.incidentList
                        }
                        $scope.$apply()

                    }
                })
            }
*/

        /* var immunizationExists = Doctor_Immunization.findOne({
             "type": "reply",
             "user_id": userId
         })
         var fullImmuzations = Doctor_Immunization.findOne({
             type: "questions"
         })*/
        let immunizationExists = []
        let fullImmuzations = []
        let questions = []
        if (immunizationExists && fullImmuzations) {
            if (immunizationExists.questions_answers) {
                _.each(immunizationExists.questions_answers, function(quest) {
                        if (immunizationExists.status == "sent") {
                            let findQuest = _.find(fullImmuzations.questions, function(doc) {
                                return doc._id == quest._id
                            })
                            findQuest.q_type = findQuest.q_type ? findQuest.q_type : null
                            questions.push({
                                q_type: findQuest.q_type,
                                question: findQuest.question,
                                type: findQuest.type,
                                _id: findQuest._id,
                                q_type: findQuest.q_type
                            })
                        } else {
                            let findQuest = _.find(fullImmuzations.questions, function(doc) {
                                return doc._id == quest._id
                            })
                            findQuest.q_type = findQuest.q_type ? findQuest.q_type : null
                            questions.push({
                                q_type: findQuest.q_type,
                                question: findQuest.question,
                                answer: quest.answer,
                                type: findQuest.type,
                                _id: findQuest._id,
                                q_type: findQuest.q_type
                            })
                        }
                    })
                    /******************Medical incidents start************************/
                if ($scope.result && $scope.result.incidents) {
                    _.each($scope.result.incidents, function(incident) {
                        // if (incident.doctor_id === self.loggedUserId) {
                        // if(incident.type =='emergency_referral'){
                        if (incident.follow_up) {
                            incident.canFollow = false //cannot add but view
                        } else {
                            incident.canFollow = true // can add not view
                        }
                        incident.emergency = {}
                        if (incident.type == 'emergency_referral') {
                            if (incident.injury_level == "1") {
                                incident.emergency = "Temporary Disablity"
                            } else if (incident.injury_level == "2") {
                                incident.emergency = "Chronic disability"
                            } else if (incident.injury_level == "3") {
                                incident.emergency = "Dead"
                            } else if (incident.injury_level == "4") {
                                incident.emergency = "Mild"
                            }
                        }
                        // }
                        // incidentObs.push(incident)
                        // }
                    })
                    $scope.incidentList = $scope.result.incidents
                }
                /******************Medical incidents Ends************************/

            }
            $scope.immunizationResults = questions
            if (immunizationExists.status == "sent") {
                $scope.enterAnswers = true
                $scope.viewAnswers = false
                $scope.sent_date = immunizationExists.sent_date
            } else {
                $scope.viewAnswers = true
                $scope.enterAnswers = false
                $scope.reply_date = immunizationExists.reply_date
                $scope.sent_date = immunizationExists.reply_date
            }
        }

        if ($scope.immunizationResults) {
            if ($scope.immunizationResults.length > 0) {
                $scope.immunizationResults[0].expanded = true;
            }

            $scope.collapseMedicalHistory = function(expa) {
                for (var i in $scope.immunizationResults) {
                    if ($scope.immunizationResults[i] != expa) {
                        $scope.immunizationResults[i].expanded = false;
                    }
                }
                expa.expanded = !expa.expanded;
            };
        }
        /******************Accordian collapse for medical history ends************************/
        $scope.collapseAll = function(data) {
            for (var i in $scope.medicalhistory) {
                if ($scope.medicalhistory[i] != data) {
                    $scope.medicalhistory[i].expanded = false;
                }
            }
            data.expanded = !data.expanded;
        };
        $scope.collapseHistory = function(data) {
            for (var i in $scope.incidentList) {
                if ($scope.incidentList[i] != data) {
                    $scope.incidentList[i].expanded = false;
                }
            }
            data.expanded = !data.expanded;
        };


        $scope.sendImmunization = () => {
            var error = 0
            $scope.immuneError = {}
            $scope.descriptiveError = [];
            $scope.objectiveError = []
            $scope.timeError = []
            _.each($scope.immunizationResults, function(result, key) {
                if (result.type == "objective") {
                    if (result.objective != "0" && result.objective != "1") {
                        $scope.objectiveError[key] = "please select answer"
                        error++
                    }
                } else if (result.type == "time") {

                    if (!result.startDate) {
                        error++
                        $scope.timeError[key] = "please select date"
                    } else {

                    }
                } else if (result.type == "descriptive") {

                    if (!result.answer || result.answer[key] === "" || result.answer[key] === null || result.answer[key] === undefined) {
                        error++
                        $scope.descriptiveError[key] = "please enter answer"
                    }
                }
            })
            if (error === 0) {
                let userReply = angular.copy($scope.immunizationResults)
                let obj = {
                        user_reply: userReply,
                        patient_id: userId
                    }
                authService.callAPI(MEDICALCONSTANT.API_SAVE_USER_REPLY, "POST", obj, (response) => {
                    if (response.result && response.result.data && response.result.data.data) {
                            toastr.success("Reply send successfully")
                            getImmunizationForm()
                        
                        _.defer(function() {
                            $scope.$apply();
                        });
                    }
                })
            }
        }

        /* $scope.addComment = (data, index) => {

             if (data.follow_up == "" || data.follow_up == null) {
                 toastr.error("Please enter a comment");
                 return false
             } else {
                 Meteor.call("addFollowUp", data, Meteor.userId(), function(error, res) {
                     if (error) {
                         toastr.error(error.reason);
                     } else {
                         toastr.success("Successfully added followup");

                     }
                 })
             }
         }*/



    }
}
export default MedicalProfileController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/myMedicalProfile.js